import { COLOR_THEMES } from '@/static/themes'
import { Media } from './Media'
import { Theme } from './Theme'
import { UserFlags } from './User'

export const UserGenders = ['man', 'woman', 'nb'] as const

export const UserRelationship = [ 'single', 'relationship', 'couple', 'open', 'complicated', 'hide' ] as const

export type UserAnecdote = {
  question: string
  gif?: string
  text?: string
}

export const UserGoals = {
  chill: {
    image: 'Relieved+Face',
    theme: COLOR_THEMES.tiger as Theme
  },
  serious: {
    image: 'Red+Heart',
    theme: COLOR_THEMES.flamingo as Theme
  },
  friends: {
    image: 'Waving+Hand',
    theme: COLOR_THEMES.butterfly as Theme
  },
  spicy: {
    image: 'Fire',
    theme: COLOR_THEMES.ruby as Theme
  },
  nothing: {
    image: 'Face+in+Clouds',
    theme: COLOR_THEMES.urchin as Theme
  }
 } as const

export type UserSong = {
  track?: string
  artist?: string
  album?: string
}

export interface IUserProfile {
  _id: string

  relationship: typeof UserRelationship[number]
  genders: (typeof UserGenders[number])[]
  
  flags: (typeof UserFlags[number])[]

  goal: keyof typeof UserGoals
  bio: string
  kinks: string
  checkedAt: Date | null
  banner: string
  songs: UserSong[]
  anecdotes: UserAnecdote[]
  zodiac: keyof typeof ZODIAC_SIGNS | '' | 'hidden'

  weeklyBestie: {
    id: string
    answers: number[]
  }[]

  isShowAge: boolean
  isShowEvents: boolean
  isShowLanguages: boolean
  groups: string[]

  post: string
  owner: string
}